'use client';
import React from 'react';
export function VersionPill({ version }: { version: string }) {
  return <span className="inline-flex items-center rounded-full border px-2 py-0.5 text-xs font-medium text-gray-700 bg-white/70 shadow-sm">{version}</span>;
}
